<template>
    <div class="assignments">
        <div id="scrolled-element-id" class="tab-pane active">
            <div v-if="dutiesArray.length > 0" class="shift-name no-print" @mousedown.stop>
                <SelectBox
                    v-model="selectedShift"
                    style-class="inline"
                    placeholder="Shift name"
                    :options="dutiesArray"
                />
            </div>
            <div
                v-show="hasDataToDisplay"
                ref="asgtable"
                v-selectable="{
                    selectedGetter: selectedLocationsGetter,
                    selectedSetter: selectedLocationsSetter,
                    selectingSetter: selectingLocationsSetter,
                }"
                class="table-wrapper no-print"
                data-items=".selectable"
                data-box=".selection-box"
                data-constraint=".selection-constraint"
            >
                <div class="selection-box"></div>
                <div class="selection-constraint"></div>
                <div v-show="!searchKeyword || !nothingFound" class="table-assignments">
                    <div class="theader" @mousedown.stop>
                        <div
                            :class="[
                                'location',
                                { expanded: expandedLocationIds.length === rootLocations.length },
                            ]"
                        >
                            <div class="chewron">
                                <i class="icon-chewron-down" @click="toggleExpandedLocations" @mousedown.stop>
                                </i>
                            </div>
                            <span>{{ $t('roomConfiguration.location') }} ({{ numberOfShownLocations }})</span>
                        </div>
                        <div class="inline-theader">
                            <div class="grid-theader">
                                <div class="grid-assignments">
                                    <div
                                        v-if="assignmentsConf.assignments_type !== 2"
                                        class="direct assignment"
                                    >
                                        {{ $t('assignments.first') }}
                                        <span> {{ $t('assignments.direct') }}</span>
                                        {{ $t('assignments.assignment') }}
                                    </div>
                                    <div
                                        v-if="
                                            assignmentsConf.assignments_type !== 2 &&
                                                assignmentsConf.assignments_level === 1
                                        "
                                        class="direct assignment"
                                    >
                                        {{ $t('assignments.second') }}
                                        <span> {{ $t('assignments.direct') }}</span>
                                        {{ $t('assignments.assignment') }}
                                    </div>
                                    <div
                                        v-if="assignmentsConf.assignments_type !== 1"
                                        class="duty assignment"
                                    >
                                        {{ $t('assignments.first') }}
                                        <span> {{ $t('assignments.duty') }}</span>
                                        {{ $t('assignments.assignment') }}
                                    </div>
                                    <div
                                        v-if="
                                            assignmentsConf.assignments_type !== 1 &&
                                                assignmentsConf.assignments_level === 1
                                        "
                                        class="duty assignment"
                                    >
                                        {{ $t('assignments.second') }}
                                        <span> {{ $t('assignments.duty') }}</span>
                                        {{ $t('assignments.assignment') }}
                                    </div>
                                </div>
                                <div v-if="assignmentsConf.show_catch_net" class="catch-net">
                                    {{ $t('assignments.catchNet') }}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="tbody">
                        <div
                            v-for="(location, locIdx) in displayedLocations"
                            v-show="isLocationShown(location)"
                            :key="location.location_id"
                            :locationId="location.location_id"
                            :class="[
                                'arow',
                                arowStyle(location),
                                {
                                    expanded: isLocationExpanded(location),
                                    alone: !locationHasChildren(location) && !location.parent_id,
                                },
                            ]"
                            @dblclick.prevent="toggleExpandedLocation(location)"
                        >
                            <div
                                v-show="!location.parent_id && !hasStaffRecursive(location)"
                                class="no-staff-warning"
                            >
                                {{ $t('assignments.noAssignedStaff') }}
                            </div>
                            <div
                                v-show="!location.parent_id && staffOverloaded(location)"
                                class="staff-overload-message"
                            >
                                <i class="icon-allert"></i>
                                <span>
                                    {{ $t('assignments.staffOverload') }}
                                </span>
                            </div>
                            <div :class="['aname', { matches: !!searchKeyword && matchesKeyword(location) }]">
                                <div
                                    v-show="isRoomLocationSubtreeInvalid(location)"
                                    class="error-bullet-wrapper"
                                    :data-error-location="
                                        isRoomLocationSubtreeInvalid(location)
                                            ? $t('validators.assignmentsLocationSomeErrors')
                                            : ''
                                    "
                                >
                                    <div class="error-bullet"></div>
                                </div>
                                <div v-show="!location.parent_id" class="chewron">
                                    <i
                                        class="icon-chewron-down"
                                        @click="toggleExpandedLocation(location)"
                                        @mousedown.stop
                                    ></i>
                                </div>
                                <span
                                    :class="[
                                        'selectable',
                                        {
                                            selecting: selectingLocations[locIdx],
                                            selected: selectedLocations[locIdx],
                                            'color-red': isRoomLocationSubtreeInvalid(location),
                                        },
                                    ]"
                                    :title="location.name"
                                >
                                    {{ location.name }}
                                </span>
                            </div>
                            <div
                                v-if="
                                    expandedLocationIds.some(id =>
                                        [location.parent_id, location.location_id].includes(id)
                                    )
                                "
                                class="lrow"
                            >
                                <div
                                    v-if="assignmentsConf.show_resident_call"
                                    :class="[
                                        'subrow',
                                        'color-' +
                                            (!!assignmentsConf.resident_color
                                                ? assignmentsConf.resident_color
                                                : 2),
                                    ]"
                                    @dblclick.stop
                                >
                                    <div class="dio-name" :title="assignmentsConf.resident_call_name">
                                        {{ assignmentsConf.resident_call_name.charAt(0).toUpperCase() }}
                                    </div>
                                    <div class="acells">
                                        <div class="acells-assignments">
                                            <AssignmentCell
                                                v-if="assignmentsConf.assignments_type !== 2"
                                                cell-type="dio1"
                                                :location-id="location.location_id"
                                                :cell-data="location.dio1"
                                                :on-cell-click="openSelectionBox"
                                                :on-cell-item-click="removeStaff"
                                                :on-cell-hover="showCellError"
                                            />
                                            <AssignmentCell
                                                v-if="
                                                    assignmentsConf.assignments_type !== 2 &&
                                                        assignmentsConf.assignments_level === 1
                                                "
                                                cell-type="dio2"
                                                :location-id="location.location_id"
                                                :cell-data="location.dio2"
                                                :on-cell-click="openSelectionBox"
                                                :on-cell-item-click="removeStaff"
                                                :on-cell-hover="showCellError"
                                            />
                                            <AssignmentCell
                                                v-if="assignmentsConf.assignments_type !== 1"
                                                cell-type="duo1"
                                                :location-id="location.location_id"
                                                :cell-data="location.duo1[selectedShift]"
                                                :on-cell-click="openSelectionBox"
                                                :on-cell-item-click="removeStaff"
                                                :on-cell-hover="showCellError"
                                            />
                                            <AssignmentCell
                                                v-if="
                                                    assignmentsConf.assignments_type !== 1 &&
                                                        assignmentsConf.assignments_level === 1
                                                "
                                                cell-type="duo2"
                                                :location-id="location.location_id"
                                                :cell-data="location.duo2[selectedShift]"
                                                :on-cell-click="openSelectionBox"
                                                :on-cell-item-click="removeStaff"
                                                :on-cell-hover="showCellError"
                                            />
                                        </div>
                                        <AssignmentCellDefault
                                            v-if="assignmentsConf.show_catch_net"
                                            cell-type="deo"
                                            assignment-type="observers"
                                            :number-of-lines="
                                                catchNetLineInfo[location.location_id]['observers']
                                                    .numberOfLines
                                            "
                                            :selected-shift="selectedShift"
                                            :assignments="location.assignments"
                                            :default-assignment-chain="defaultAssignmentChain"
                                            :default-assignment-only="defaultAssignmentOnly"
                                            :on-cell-click="openModalWithDefaults"
                                            :default-assignment-chain-last-part="
                                                defaultAssignmentChainLastPart
                                            "
                                        />
                                    </div>
                                </div>
                                <div
                                    v-if="assignmentsConf.show_staff_call"
                                    :class="[
                                        'subrow',
                                        'color-' +
                                            (!!assignmentsConf.staff_color ? assignmentsConf.staff_color : 1),
                                    ]"
                                    @dblclick.stop
                                >
                                    <div class="dia-name" :title="assignmentsConf.staff_call_name">
                                        {{ assignmentsConf.staff_call_name.charAt(0).toUpperCase() }}
                                    </div>
                                    <div class="acells">
                                        <div class="acells-assignments">
                                            <AssignmentCell
                                                v-if="assignmentsConf.assignments_type !== 2"
                                                cell-type="dia1"
                                                :location-id="location.location_id"
                                                :cell-data="location.dia1"
                                                :on-cell-click="openSelectionBox"
                                                :on-cell-item-click="removeStaff"
                                                :on-cell-hover="showCellError"
                                            />
                                            <AssignmentCell
                                                v-if="
                                                    assignmentsConf.assignments_type !== 2 &&
                                                        assignmentsConf.assignments_level === 1
                                                "
                                                cell-type="dia2"
                                                :location-id="location.location_id"
                                                :cell-data="location.dia2"
                                                :on-cell-click="openSelectionBox"
                                                :on-cell-item-click="removeStaff"
                                                :on-cell-hover="showCellError"
                                            />
                                            <AssignmentCell
                                                v-if="assignmentsConf.assignments_type !== 1"
                                                cell-type="dua1"
                                                :location-id="location.location_id"
                                                :cell-data="location.dua1[selectedShift]"
                                                :on-cell-click="openSelectionBox"
                                                :on-cell-item-click="removeStaff"
                                                :on-cell-hover="showCellError"
                                            />
                                            <AssignmentCell
                                                v-if="
                                                    assignmentsConf.assignments_type !== 1 &&
                                                        assignmentsConf.assignments_level === 1
                                                "
                                                cell-type="dua2"
                                                :location-id="location.location_id"
                                                :cell-data="location.dua2[selectedShift]"
                                                :on-cell-click="openSelectionBox"
                                                :on-cell-item-click="removeStaff"
                                                :on-cell-hover="showCellError"
                                            />
                                        </div>
                                        <AssignmentCellDefault
                                            v-if="assignmentsConf.show_catch_net"
                                            cell-type="dea"
                                            assignment-type="assistance"
                                            :number-of-lines="
                                                catchNetLineInfo[location.location_id]['assistance']
                                                    .numberOfLines
                                            "
                                            :selected-shift="selectedShift"
                                            :assignments="location.assignments"
                                            :default-assignment-chain="defaultAssignmentChain"
                                            :default-assignment-only="defaultAssignmentOnly"
                                            :on-cell-click="openModalWithDefaults"
                                            :default-assignment-chain-last-part="
                                                defaultAssignmentChainLastPart
                                            "
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div
                            v-show="selectionVisible"
                            id="select-dropdown"
                            v-on-clickaway="hideSelection"
                            class="selection-list"
                            :style="[selectionVisible ? selectBoxStyles : '']"
                        >
                            <div class="select-dropdown-search">
                                <input
                                    id="forAT_selection-search"
                                    ref="search"
                                    v-model="selectionSearch"
                                    type="text"
                                    :placeholder="$t('common.searchPlaceholder')"
                                    tabindex="1"
                                    autocomplete="off"
                                    @keyup.down="pointerForward"
                                    @keyup.up="pointerBackward"
                                    @keydown.enter.stop.prevent.self="addPointerElement"
                                />
                                <label for="forAT_selection-search" class="label-for-screen-reader">
                                    {{ $t('common.searchPlaceholder') }}
                                </label>
                            </div>
                            <Simplebar class="with-border-track" :style="[selectBoxListStyles]">
                                <ul ref="list">
                                    <li
                                        v-for="(staff, index) in filteredAssignableStaff"
                                        :key="index"
                                        :class="{
                                            selected: selectionTarget.selectedStaff.includes(staff.id),
                                            highlight: index === pointer,
                                        }"
                                        :title="staff.callIds.join(', ')"
                                        @click.stop="selectStaff(staff.id)"
                                        @mouseenter="pointer = index"
                                    >
                                        <i v-if="staff.isGroup" class="icon-staff-group"></i>
                                        <span class="staff-title">{{ staff.title }}</span>
                                        <div v-show="staff.overloaded" class="icon-overloaded-staff">
                                            <i class="icon-allert"></i>
                                        </div>
                                    </li>
                                    <li v-show="filteredAssignableStaff.length === 0">
                                        <span v-show="selectionSearch">
                                            {{ $t('common.noSearchResults') }}
                                        </span>
                                        <span v-if="!selectionSearch">
                                            {{ $t('assignments.noAssignableStaff') }}
                                        </span>
                                    </li>
                                </ul>
                            </Simplebar>
                        </div>
                    </div>
                </div>
                <h3 v-if="searchKeyword && nothingFound">
                    {{ $t('common.searchNoResult', { val: searchKeyword }) }}
                </h3>
            </div>
            <div v-if="dataLoaded && !hasDataToDisplay" class="data-empty">
                <h3 v-text="$t('assignments.noAssignmentsData')"></h3>
            </div>
            <Modal
                :show="showDefault"
                :title="
                    $t(modalDefaultData.observers ? 'assignments.defaultObserv' : 'assignments.defaultAssist')
                "
                :with-scroll="true"
                style-class="modal-assignments"
                @close="showDefault = false"
            >
                <div class="catch-net">
                    <div v-for="(group, index) in modalDefaultData.groups" :key="index">
                        <div class="arrow">
                            <span><i class="icon-arrow-right"></i></span>
                        </div>
                        <div class="col">
                            <span v-if="group[0]" :title="group[0]"> {{ group[0] }} </span>
                            <div v-if="group.length > 0">
                                <template v-for="(number, index2) in group">
                                    <span v-if="index2 > 0" :key="index2" :title="number">
                                        <i class="icon-phone"></i>{{ number }}
                                    </span>
                                </template>
                            </div>
                        </div>
                    </div>
                    <h3 v-if="!modalDefaultData.groups.length">{{ $t('assignments.defaultIsEmpty') }}</h3>
                </div>
            </Modal>
            <h4 v-if="searchAppliesForPrint" class="print-only">
                {{ $t('print.search', { val: searchKeyword }) }}
            </h4>
            <div v-show="hasDataToDisplay" class="print-only">
                <div>
                    <h2 class="assignments">
                        {{ $t('assignments.shift') }}: {{ currentShift.name }} ({{
                            currentShift.clarification()
                        }})
                    </h2>
                    <table class="assignment-print">
                        <thead>
                            <tr>
                                <th>{{ $t('roomConfiguration.location') }}</th>
                                <th></th>
                                <th v-if="assignmentsConf.assignments_type !== 2">
                                    {{ $t('assignments.first') + ' ' + $t('assignments.direct') }}
                                </th>
                                <th
                                    v-if="
                                        assignmentsConf.assignments_type !== 2 &&
                                            assignmentsConf.assignments_level === 1
                                    "
                                >
                                    {{ $t('assignments.second') + ' ' + $t('assignments.direct') }}
                                </th>
                                <th v-if="assignmentsConf.assignments_type !== 1">
                                    {{ $t('assignments.first') + ' ' + $t('assignments.duty') }}
                                </th>
                                <th
                                    v-if="
                                        assignmentsConf.assignments_type !== 1 &&
                                            assignmentsConf.assignments_level === 1
                                    "
                                >
                                    {{ $t('assignments.second') + ' ' + $t('assignments.duty') }}
                                </th>
                                <th v-if="assignmentsConf.show_catch_net">
                                    {{ $t('assignments.catchNet') }}
                                </th>
                            </tr>
                        </thead>
                        <tbody v-for="location in locationsPrintable" :key="location.location_id">
                            <tr
                                v-if="assignmentsConf.show_resident_call"
                                :class="{ 'only-row': !assignmentsConf.show_staff_call }"
                            >
                                <td :class="{ bed: !!location.parent_id }">{{ location.name }}</td>
                                <td class="call-type">
                                    <span>{{ assignmentsConf.resident_call_name }}</span>
                                </td>
                                <td v-for="(type, index) in shownCells('observers')" :key="index">
                                    <span
                                        v-for="item in assignmentArrayByCellType(
                                            selectedShift,
                                            type,
                                            location.assignments
                                        )"
                                        :key="item.id"
                                    >
                                        <i v-if="item.isGroup" class="icon-staff-group"></i>
                                        {{
                                            item.title +
                                                (item.callIds ? ' (' + item.callIds.join(', ') + ')' : '')
                                        }}
                                    </span>
                                </td>
                                <td v-if="assignmentsConf.show_catch_net">
                                    <span
                                        v-if="
                                            !defaultAssignmentChain(
                                                selectedShift,
                                                'observers',
                                                location.assignments
                                            ).length
                                        "
                                        v-text="$t('assignments.defaultIsEmpty')"
                                    ></span>
                                    <template v-else>
                                        <span
                                            v-if="
                                                defaultAssignmentOnly(
                                                    selectedShift,
                                                    'observers',
                                                    location.assignments
                                                )
                                            "
                                        >
                                            <span
                                                class="chain-colorbox"
                                                :class="
                                                    'chain-color' +
                                                        defaultAssignmentColor(
                                                            selectedShift,
                                                            'observers',
                                                            location.assignments
                                                        )
                                                "
                                            ></span>
                                            {{
                                                $t(
                                                    'assignments.colors.c' +
                                                        defaultAssignmentColor(
                                                            selectedShift,
                                                            'observers',
                                                            location.assignments
                                                        )
                                                )
                                            }}
                                        </span>
                                        <span v-else>
                                            {{
                                                defaultAssignmentChainLastPart(
                                                    selectedShift,
                                                    'observers',
                                                    location.assignments
                                                )[0]
                                            }}
                                        </span>
                                    </template>
                                </td>
                            </tr>
                            <tr
                                v-if="assignmentsConf.show_staff_call"
                                :class="{ 'only-row': !assignmentsConf.show_resident_call }"
                            >
                                <td
                                    :class="{
                                        bed: !!location.parent_id && !assignmentsConf.show_resident_call,
                                    }"
                                >
                                    {{ !assignmentsConf.show_resident_call ? location.name : '' }}
                                </td>
                                <td class="call-type">
                                    <span>{{ assignmentsConf.staff_call_name }}</span>
                                </td>
                                <td v-for="(type, index) in shownCells('assistance')" :key="index">
                                    <span
                                        v-for="item in assignmentArrayByCellType(
                                            selectedShift,
                                            type,
                                            location.assignments
                                        )"
                                        :key="item.id"
                                    >
                                        <i v-if="item.isGroup" class="icon-staff-group"></i>
                                        {{
                                            item.title +
                                                (item.callIds ? ' (' + item.callIds.join(', ') + ')' : '')
                                        }}
                                    </span>
                                </td>
                                <td v-if="assignmentsConf.show_catch_net">
                                    <span
                                        v-if="
                                            !defaultAssignmentChain(
                                                selectedShift,
                                                'assistance',
                                                location.assignments
                                            ).length
                                        "
                                        v-text="$t('assignments.defaultIsEmpty')"
                                    ></span>
                                    <template v-else>
                                        <span
                                            v-if="
                                                defaultAssignmentOnly(
                                                    selectedShift,
                                                    'assistance',
                                                    location.assignments
                                                )
                                            "
                                        >
                                            <span
                                                class="chain-colorbox"
                                                :class="
                                                    'chain-color' +
                                                        defaultAssignmentColor(
                                                            selectedShift,
                                                            'assistance',
                                                            location.assignments
                                                        )
                                                "
                                            ></span>
                                            {{
                                                $t(
                                                    'assignments.colors.c' +
                                                        defaultAssignmentColor(
                                                            selectedShift,
                                                            'assistance',
                                                            location.assignments
                                                        )
                                                )
                                            }}
                                        </span>
                                        <span v-else>
                                            {{
                                                defaultAssignmentChainLastPart(
                                                    selectedShift,
                                                    'assistance',
                                                    location.assignments
                                                )[0]
                                            }}
                                        </span>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="huntingChainsMessageGroups.hc.length > 0 && assignmentsConf.show_catch_net">
                    <h2 class="assignments">{{ $t('assignments.huntingChains') }}</h2>
                    <div v-for="hc in orderedHCMessageGrByColor" :key="hc.color" class="hunting-chain">
                        <h3>
                            <span class="chain-colorbox" :class="'chain-color' + hc.color"></span>
                            {{ $t('assignments.colors.c' + hc.color) }}
                        </h3>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>{{ $t('assignments.callType') }}</th>
                                    <th>{{ $t('assignments.first') }}</th>
                                    <th>{{ $t('assignments.second') }}</th>
                                    <th>{{ $t('assignments.third') }}</th>
                                    <th>{{ $t('assignments.fourth') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="!!hc.observers">
                                    <td>{{ assignmentsConf.resident_call_name }}</td>
                                    <td v-for="(i, index) in [0, 1, 2, 3]" :key="index">
                                        <template v-if="hc.observers[i]">
                                            <div v-for="(hcName, index2) in hc.observers[i]" :key="index2">
                                                <i class="icon-phone"></i> {{ hcName }}
                                            </div>
                                        </template>
                                    </td>
                                </tr>
                                <tr v-if="!!hc.assistance">
                                    <td>{{ assignmentsConf.staff_call_name }}</td>
                                    <td v-for="(i, index) in [0, 1, 2, 3]" :key="index">
                                        <template v-if="hc.assistance[i]">
                                            <div v-for="(hcName, index2) in hc.assistance[i]" :key="index2">
                                                <i class="icon-phone"></i> {{ hcName }}
                                            </div>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div v-if="huntingChainsMessageGroups.mg.length > 0 && assignmentsConf.show_catch_net">
                    <h2 class="assignments">{{ $t('assignments.messageGroups') }}</h2>
                    <div v-for="(mg, index) in orderedHCMessageGrByName" :key="index">
                        <p>
                            <b>{{ mg.name }}:</b> {{ mg.callIds.join(', ') }}
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <Pagination
            v-show="pagination.last_page > 1"
            v-model="pagination.current_page"
            class="no-print"
            :options="pagination"
            :callback="onPageChange"
        />
    </div>
</template>

<script type="text/babel">
import { mapActions, mapMutations, mapState } from 'vuex';
import orderBy from 'lodash-es/orderBy';
import uniq from 'lodash-es/uniq';
import isEmpty from 'lodash-es/isEmpty';
import find from 'lodash-es/find';
import some from 'lodash-es/some';
import cloneDeep from 'lodash-es/cloneDeep';
import SelectBox from './common/SelectBox.vue';
import Modal from './common/Modal.vue';
import { sortLocations, ifIsNotCanceled } from './common/helpers';
import { mixin as clickaway } from 'vue-clickaway';
import mappingState from './common/mappingState';
import assignmentsUtils from './assignments/assignmentsUtils';
import AssignmentCell from './assignments/AssignmentCell';
import AssignmentCellDefault from './assignments/AssignmentCellDefault';
import Pagination from './common/Pagination';
import Simplebar from 'simplebar-vue';
import selectable, { setSelectableItems, setOptions } from 'ascom-selectable';
import {
    resourceAssignments,
    resourceStaffMembers,
    resourceStaffGroupsInAA,
    resourceDuties,
} from '../api/resources';
import { getCancelToken } from '../api';
import {
    SUCCESS,
    ERROR,
    ASSIGNMENTS_MAX_LENGTH,
    ASSIGNMENTS_ROOMS_PER_PAGE,
    DEFAULT_OPTION_HEIGHT_SSMENU,
    MAX_ELEMENTS_SSMENU,
    LOCATIONS_FOR_SAVE_NUMBER,
    MAX_PHONES_FOR_SAVE,
    USER_TYPES,
} from '../constants';
import { updateStaffMembers } from './staff/staffUtils';
import store from '../store';

let dutiesLoaded;
let locationsLoaded;
let staffGroups = [];
let staff = [];
let selectedNode = null;

export default {
    name: 'Assignments',

    components: {
        AssignmentCell,
        AssignmentCellDefault,
        Pagination,
        SelectBox,
        Modal,
        Simplebar,
    },

    directives: {
        selectable,
    },

    mixins: [clickaway, mappingState, assignmentsUtils],

    data() {
        return {
            dataLoaded: false,
            locations: [],
            locationsCopy: [],
            filteredLocations: [],
            // displayedLocations: [],
            displayedLocationsPages: [[]],
            dutiesArray: [],
            staffArray: [],
            selectedShift: null,
            prevSelectedShift: null,
            pointer: 0,
            itemHeightInSelectBox: DEFAULT_OPTION_HEIGHT_SSMENU,
            numberItemsInSelectBox: MAX_ELEMENTS_SSMENU,
            maxItemsInSelectBox: MAX_ELEMENTS_SSMENU,
            selectionElement: null,
            selectDropdownSearch: null,
            scrolledElement: document.getElementById('scrolled-element-id'),
            tableAssignemntsDomElement: null,
            assignmentsChanged: false,
            expandedLocationIdsFromData: [],
            locationsInvalid: [],
            selectionVisible: false,
            selectionSearch: '',
            selectionTarget: {
                location: null,
                cell: '',
                selectedStaff: [],
            },
            watchedKeyword: '',
            showDefault: false,
            modalDefaultData: {
                observers: true,
                groups: [],
            },
            selectedLocations: [],
            selectingLocations: [],
            selectBoxTop: undefined,
            selectBoxLeft: undefined,
            selectBoxWidth: undefined,
            cancelToken: getCancelToken(),
            catchNetLines: [], // [ { location_id, type, numberOfLines } ]
            pagination: {
                current_page: 1,
                last_page: 0,
                per_page: ASSIGNMENTS_ROOMS_PER_PAGE,
            },
        };
    },

    computed: {
        ...mapState({
            expandedLocationIdsFromStore: state => state.assignments.expandedLocationIds,
            scrollPosition: state => state.assignments.scrollPosition,
            savedShift: state => state.assignments.selectedShift,
            savedCurrentPage: state => state.assignments.savedCurrentPage,
        }),

        assignableStaff() {
            return this.staffArray.filter(
                item =>
                    item.assignable &&
                    item.callIds.length > 0 &&
                    (item.type !== USER_TYPES.SUPER_USER ||
                        (this.userType === USER_TYPES.SUPER_USER && item.id === this.userId))
            );
        },

        nothingFound() {
            return (
                this.searchKeyword &&
                !this.locations.some(
                    i => i.name.toLowerCase().indexOf(this.searchKeyword.toLowerCase()) !== -1
                )
            );
        },

        selectBoxListStyles() {
            return {
                'max-height': this.selectBoxHeight + 'px',
            };
        },

        selectBoxHeight() {
            return (
                this.itemHeightInSelectBox *
                Math.min(this.filteredAssignableStaff.length, this.numberItemsInSelectBox)
            );
        },

        assignmentsInvalid() {
            return this.locations.some(location => !location.valid);
        },

        hasDataToDisplay() {
            return !!this.locations && this.locations.length > 0 && this.dutiesArray.length > 0;
        },

        searchAppliesForPrint() {
            return this.searchKeyword && this.locationsCopy.some(i => this.matchesKeyword(i));
        },

        expandedLocationIds() {
            if (this.searchKeyword) {
                return this.expandedLocationIdsFromData;
            }

            return this.expandedLocationIdsFromStore;
        },

        rootLocations() {
            return this.locations.filter(location => !location.parent_id);
        },

        displayedLocations() {
            return (
                (this.locations.length > 0 &&
                    this.displayedLocationsPages[this.pagination.current_page - 1]) ||
                []
            );
        },

        locationsPrintable() {
            return this.searchAppliesForPrint
                ? this.locationsCopy.filter(i => this.matchesWithLinked(i))
                : this.locationsCopy;
        },

        numberOfShownLocations() {
            if (this.searchKeyword) {
                return this.locations.reduce((quantity, location) => {
                    return this.matchesWithLinked(location) ? quantity + 1 : quantity;
                }, 0);
            }

            return this.locations.length;
        },

        catchNetLineInfo() {
            // result = {
            //     0000: {
            //         observers: { locationId, numberOfLines, type },
            //         assistance: { locationId, numberOfLines, type },
            //     },
            // }
            let locations = this.locations.reduce((all, location) => {
                return Object.assign(all, {
                    [location.location_id]: {
                        observers: {},
                        assistance: {},
                    },
                });
            }, {});

            return this.catchNetLines.reduce((catchNetLineInfo, item) => {
                return Object.assign(catchNetLineInfo, {
                    [item.locationId]: Object.assign(catchNetLineInfo[item.locationId] || {}, {
                        [item.type]: item,
                    }),
                });
            }, locations);
        },

        /**
         * Gets current shift object
         * @return {{name: String, clarification: Function}}
         */
        currentShift() {
            let s = {
                name: '',
                clarification: function() {
                    return '';
                },
            };

            return this.dutiesArray.length > 0
                ? this.dutiesArray.find(i => i.value === this.selectedShift) || s
                : s;
        },

        /**
         * Returns data array for print with  message groups hunting chains
         * @return {{ hc: {color: int, observers: String[], assistance: String[]}[], mg: {name: String, callIds: String[]}[] }}
         */
        huntingChainsMessageGroups() {
            return this.locationsPrintable.reduce(
                (a, l) => {
                    let result = {
                        hc: [...a.hc],
                        mg: [...a.mg],
                    };
                    let color;
                    let asg;
                    let callTypes = [];
                    if (this.assignmentsConf.show_staff_call) {
                        callTypes.push('assistance');
                    }
                    if (this.assignmentsConf.show_resident_call) {
                        callTypes.push('observers');
                    }
                    for (let t of callTypes) {
                        asg = this.defaultAssignmentChain(this.selectedShift, t, l.assignments);
                        if (!asg.length) {
                            continue;
                        }
                        if (this.defaultAssignmentOnly(this.selectedShift, t, l.assignments)) {
                            color = this.defaultAssignmentColor(this.selectedShift, t, l.assignments);
                            if (color !== undefined) {
                                let hcIdx = result.hc.findIndex(i => i.color === color);
                                let hc = hcIdx !== -1 ? result.hc[hcIdx] : { color };
                                hc[t] = asg.map(i => {
                                    let groups = i[Object.keys(i)[0]].sort((a, b) => a - b);
                                    return [Object.keys(i)[0], ...groups];
                                });
                                if (hcIdx !== -1) {
                                    result.hc.splice(hcIdx, 1, hc);
                                } else {
                                    result.hc.push(hc);
                                }
                            }
                        } else {
                            let mg = this.defaultAssignmentChainLastPart(
                                this.selectedShift,
                                t,
                                l.assignments
                            );
                            if (result.mg.findIndex(i => i.name === mg[0]) === -1) {
                                result.mg.push({
                                    name: mg[0],
                                    callIds: mg.slice(1),
                                });
                            }
                        }
                    }

                    return result;
                },
                { hc: [], mg: [] }
            );
        },

        /**
         * Returns list of assignable staff for selection list, filtered by keyword
         * @return {Object[]}
         */
        filteredAssignableStaff() {
            return this.selectionSearch.trim() === ''
                ? this.assignableStaff
                : this.assignableStaff.filter(
                      item => item.title.toLowerCase().indexOf(this.selectionSearch.trim().toLowerCase()) > -1
                  );
        },

        /**
         * Returns list of hunting chains ordered by color
         * @return {Object[]}
         */
        orderedHCMessageGrByColor() {
            return orderBy(this.huntingChainsMessageGroups.hc, 'color');
        },

        /**
         * Returns list of message groups ordered by name
         * @return {Object[]}
         */
        orderedHCMessageGrByName() {
            return orderBy(this.huntingChainsMessageGroups.mg, 'name');
        },

        /**
         * Returns object of inline styles for select box
         */
        selectBoxStyles() {
            return {
                top: this.selectBoxTop + 'px',
                left: this.selectBoxLeft + 'px',
                width: this.selectBoxWidth + 'px',
            };
        },

        changedLocations() {
            return this.locations.filter(
                (location, i) => !isEmpty(this.difference(location, this.locationsCopy[i]))
            );
        },

        /**
         * Returns object of inline styles for select box
         */
        observersErrorMessageDifferent() {
            return this.$t('validators.assignmentsDifferent', {
                val: this.assignmentsConf.staff_call_name,
            });
        },
        assistanceErrorMessageDifferent() {
            return this.$t('validators.assignmentsDifferent', {
                val: this.assignmentsConf.resident_call_name,
            });
        },
        errorMessageMax() {
            return this.$t('validators.assignmentsMaxLength', { val: ASSIGNMENTS_MAX_LENGTH });
        },
    },

    watch: {
        searchKeyword(newVal, oldVal) {
            if (oldVal !== newVal) {
                this.expandedLocationIdsFromData = this.rootLocations.map(l => l.location_id);
                this.scrolledElement.scrollTop = 0;
                this.pagination.current_page = 1;
                this.saveScrollPositionAndPage({
                    scrollPosition: 0,
                    savedCurrentPage: 1,
                });
                this.refreshFilteredLocations();
                this.resetLocationsSelection();
            }
        },

        selectionSearch(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.pointer = 0;
            }
        },

        assignmentsChanged(val) {
            this.setUnsavedChanges(val);
        },

        selectedShift() {
            this.saveShift(this.selectedShift);
        },
    },

    created() {
        this.configButton({
            buttonName: 'undoButton',
            action: () => this.loadData(),
            disabled: () => !this.assignmentsChanged,
        });
        this.configButton({
            buttonName: 'saveButton',
            action: () => this.save(),
            disabled: () => !this.assignmentsChanged || this.assignmentsInvalid,
        });
        window.addEventListener('resize', this.handlerResizeWindow);
        document.body.addEventListener('keydown', this.selectAllLocations);
        this.updateData(() => {
            this.collapseAllLocations();
            return this.loadAssignmentsData();
        });
        this.$nextTick(() => {
            this.loadAssignmentsData();
        });
        if (this.scrolledElement) {
            this.scrolledElement.addEventListener('scroll', this.handleScroll);
        }
    },

    mounted() {
        setOptions(this.$refs.asgtable, {
            scrollingFrame: document.querySelector('.tab-content'),
        });

        this.tableAssignemntsDomElement = document.querySelector('.tbody');
        this.selectionElement = document.getElementById('select-dropdown');
        this.selectDropdownSearch = this.selectionElement.querySelector('.select-dropdown-search');
    },

    beforeDestroy() {
        this.progressBarBeforeDestroy();
        selectedNode = null;
        window.removeEventListener('resize', this.handlerResizeWindow);
        document.body.removeEventListener('keydown', this.selectAllLocations);
        this.resetData();
        this.cancelToken.cancel();
        if (this.scrolledElement) {
            this.scrolledElement.removeEventListener('scroll', this.handleScroll);
        }
    },

    methods: {
        ...mapMutations({
            collapseAllLocationsInStore: 'assignments/COLLAPSE_ALL_LOCATIONS',
            collapseLocationInStore: 'assignments/COLLAPSE_LOCATION',
            expandLocationInStore: 'assignments/EXPAND_LOCATION',
            saveScrollPositionAndPage: 'assignments/SAVE_SCROLL_POSITION_AND_PAGE',
            saveShift: 'assignments/SAVE_SHIFT',
            updateData: 'SET_UPDATE_DATA',
        }),

        ...mapActions({
            progressBarStart: 'progressBar/start',
            progressBarUpdate: 'progressBar/update',
            progressBarHide: 'progressBar/hide',
            progressBarBeforeDestroy: 'progressBar/beforeDestroy',
        }),

        loadAssignmentsData() {
            this.scrolledElement = document.getElementById('scrolled-element-id');
            return this.loadAssignmentsConf()
                .then(this.loadData)
                .then(() => {
                    if (this.savedCurrentPage <= this.pagination.last_page) {
                        this.pagination.current_page = this.savedCurrentPage;
                    }
                    if (this.scrolledElement) {
                        this.scrolledElement.scrollTop = this.scrollPosition;
                        this.scrolledElement.addEventListener('scroll', this.handleScroll);
                    }
                });
        },

        /**
         * Recursively check if location or sublocations have a staff assigned
         * @param Object location with assignments property
         * @returns Boolean
         */
        hasStaffRecursive(location) {
            if (this.getPhoneNumbersCount(location.assignments) > 0) {
                return true;
            }
            let children = this.getLocationChildren(location);
            return children.some(child => this.hasStaffRecursive(child));
        },

        staffOverloaded(location) {
            if (this.hasOverloaded(location)) {
                return true;
            }
            let children = this.getLocationChildren(location);
            return children.some(child => this.hasOverloaded(child));
        },

        handleScroll() {
            if (!this.searchKeyword) {
                let scrollTop = this.scrolledElement.scrollTop;
                this.saveScrollPositionAndPage({
                    scrollPosition: scrollTop,
                    savedCurrentPage: this.searchKeyword
                        ? this.savedCurrentPage
                        : this.pagination.current_page,
                });
            }
        },

        /**
         * Select all locations currently shown (including collapsed ones)
         * @param {KeyboardEvent} e
         */
        selectAllLocations(e) {
            if (e.ctrlKey && e.keyCode === 65) {
                e.preventDefault();
                this.selectedLocations = this.displayedLocations.map(() => true);
            }
        },

        /**
         * Expands all locations if some is collapsed, and collapses all otherwise
         */
        toggleExpandedLocations() {
            if (this.expandedLocationIds.length === this.rootLocations.length) {
                this.collapseAllLocations();
            } else {
                this.rootLocations.forEach(({ location_id }) => this.expandLocation(location_id));
            }
        },

        selectingLocationsSetter(v) {
            this.selectingLocations = v;
        },

        /**
         * Returns visible assignments cells depending on assignments configuration setting
         * @param {String} callType 'assistance' or 'observers'
         * @return {Array.String} of visible cells
         */
        shownCells(callType) {
            let res = [];
            let di = callType === 'assistance' ? 'dia' : 'dio';
            let du = callType === 'assistance' ? 'dua' : 'duo';
            if (this.assignmentsConf.assignments_type !== 2) {
                res.push(di + '1');
                if (this.assignmentsConf.assignments_level === 1) {
                    res.push(di + '2');
                }
            }
            if (this.assignmentsConf.assignments_type !== 1) {
                res.push(du + '1');
                if (this.assignmentsConf.assignments_level === 1) {
                    res.push(du + '2');
                }
            }
            return res;
        },

        selectedLocationsSetter(v) {
            this.displayedLocations.forEach(location => {
                if (!this.expandedLocationIds.includes(location.location_id)) {
                    let children = this.getLocationChildren(location);

                    if (children.length > 0) {
                        let parentIdx = this.getLocationIndex(location);

                        children.forEach(child => {
                            let idx = this.getLocationIndex(child);
                            v[idx] = v[parentIdx];
                        });
                    }
                }
            });

            this.selectedLocations = v;
        },

        selectedLocationsGetter() {
            return this.selectedLocations;
        },

        /**
         * returns locations which are parent location's children
         * @param {Location} parent parent location
         * @returns {Array<Location>} parent location's children
         */
        getLocationChildren(parent) {
            return this.locations.filter(({ parent_id }) => parent_id === parent.location_id);
        },

        /**
         * returns location index from this.locations array
         * @param {Location} location
         * @returns {Number} index
         */
        getLocationIndex(location) {
            return this.displayedLocations.findIndex(
                ({ location_id }) => location_id === location.location_id
            );
        },

        getDocumentHeight() {
            const body = document.body;
            const html = document.documentElement;

            return Math.max(
                body.offsetHeight,
                body.scrollHeight,
                html.clientHeight,
                html.offsetHeight,
                html.scrollHeight
            );
        },

        /**
         * Renders CSS class names string for location entries
         * @param {object} location Location object
         * @return {String} CSS class name
         */
        arowStyle(location) {
            let index = this.locations.findIndex(item => item.location_id === location.location_id);
            if (location.parent_id) {
                let nextLocation = this.locations[index + 1];
                if (!!this.searchKeyword && this.matchesKeyword(location)) {
                    index = index + 1;
                    while (this.locations[index] && this.locations[index].parent_id) {
                        if (
                            this.matchesKeyword(this.locations[index]) ||
                            this.matchesWithLinked(this.locations[index])
                        ) {
                            nextLocation = this.locations[index];
                        }
                        index = index + 1;
                    }
                }
                return !nextLocation ||
                    !nextLocation.parent_id ||
                    (!!this.searchKeyword &&
                        !!nextLocation.parent_id &&
                        !this.matchesKeyword(nextLocation) &&
                        !this.matchesWithLinked(nextLocation))
                    ? 'last-bed-child'
                    : 'bed-child';
            }

            return '';
        },

        /**
         * Checks if location has children
         * @param {object} location Location object
         * @return {Boolean}
         */
        locationHasChildren(location) {
            return !location.parent_id && this.locations.some(i => i.parent_id === location.location_id);
        },

        /**
         * Toggle location
         * @param {obj} location Location
         */
        toggleExpandedLocation(location) {
            let location_id = location.location_id;

            if (some(this.rootLocations, { location_id })) {
                // Here if root location (otherwise location cannot be toggled)
                if (this.expandedLocationIds.includes(location_id)) {
                    this.collapseLocation(location_id);
                } else {
                    this.expandLocation(location_id);
                }
            }
        },

        /**
         * Checks if location matches to current search keyword
         * @param {object} location Location object
         * @return {Boolean}
         */
        matchesKeyword(location) {
            return (
                this.searchKeyword !== '' && location.name.toLowerCase().indexOf(this.searchKeyword) !== -1
            );
        },

        /**
         * Checks if location matches to search query with its parent or one of children
         * @param {object} location Location object
         * @return {Boolean}
         */
        matchesWithLinked(location) {
            if (this.matchesKeyword(location)) {
                return true;
            }

            if (location.parent_id) {
                let parent = this.locations.find(i => i.location_id === location.parent_id);
                return this.matchesKeyword(parent);
            }

            let children = this.locations.filter(i => i.parent_id === location.location_id);
            return children.some(this.matchesKeyword);
        },

        /**
         * Opens modal window with assignment default chain data
         * @param {int} shift Shift No (0 - 9)
         * @param {String} call Call type - observers/assistance
         * @param {object} assignment Assignments object from location
         */
        openModalWithDefaults(shift, call, assignment) {
            this.modalDefaultData.observers = call === 'observers';
            let asg = this.defaultAssignmentChain(shift, call, assignment);
            if (asg.length > 0) {
                this.modalDefaultData.groups = asg.map(i => {
                    let groupContents = i[Object.keys(i)[0]].sort((a, b) => a - b);
                    return [Object.keys(i)[0], ...groupContents];
                });
            }
            this.showDefault = true;
        },

        /**
         * Opens staff selection menu
         * @param {MouseEvent} e
         * @param {String} cell Type of cell (dia1 / duo2 - DI for DIrect, DU for duty, O_bservers or A_ssistance, 1st/2nd)
         * @param {int} locationId Location ID
         */
        openSelectionBox(e, cell, locationId) {
            e.preventDefault();
            e.stopPropagation();
            this.$root.$emit('hideHelp');

            let node = e.target;
            // find grand-parent div.acell
            while (!node.classList.contains('acell') && node.parentNode) {
                node = node.parentNode;
            }

            this.selectionVisible = true;
            this.selectionSearch = '';
            this.pointer = 0;
            this.selectionTarget = {
                location: locationId,
                cell,
                selectedStaff: this.cellSelectedStaff(this.selectedShift, locationId, cell),
            };
            this.$nextTick(() => {
                if (
                    this.$refs.list &&
                    this.$refs.list.getElementsByTagName('li').length > 0 &&
                    this.$refs.list.getElementsByTagName('li')[0].offsetHeight > 0
                ) {
                    this.itemHeightInSelectBox = this.$refs.list.getElementsByTagName('li')[0].offsetHeight;
                } else {
                    this.itemHeightInSelectBox = DEFAULT_OPTION_HEIGHT_SSMENU;
                }
            });
            this.updateSelectionBox(node);
        },

        /**
         * Opens staff selection menu
         * @param {MouseEvent} e
         */
        showCellError(e) {
            e.preventDefault();
            e.stopPropagation();

            let cell = e.target;
            let tooltiptext = cell.getElementsByClassName('tooltiptext')[0];
            if (!cell.classList.contains('tooltiperror')) {
                return;
            }
            let cellBox = cell.getBoundingClientRect();
            let tooltipBox = tooltiptext.getBoundingClientRect();
            let tableBox = this.tableAssignemntsDomElement.getBoundingClientRect();
            let toTop = tableBox.top + this.scrolledElement.scrollTop - (cellBox.top - tooltipBox.height);
            let toRight = tableBox.right - (cellBox.left + tooltipBox.width);

            if (toRight < 0) {
                tooltiptext.classList.add('right');
            } else {
                tooltiptext.classList.remove('right');
            }
            if (toTop < 0) {
                tooltiptext.classList.remove('bottom');
            } else {
                tooltiptext.classList.add('bottom');
            }
        },

        /**
         * Updates position of selection list after cell data change
         * @param {Node} node
         */
        updateSelectionBox(node) {
            let parent = node.parentNode;
            let granPa = parent.parentNode;
            let highLevelParent = granPa.parentNode.parentNode;
            // move selection box to position under clicked cell
            let box = node.getBoundingClientRect();
            selectedNode = node;

            this.$nextTick(() => {
                this.selectBoxLeft = node.offsetLeft;
                this.selectBoxWidth = box.width;

                let tableTop = this.tableAssignemntsDomElement.getBoundingClientRect().top;

                let heightAboveBox = box.top - tableTop - this.scrolledElement.scrollTop;
                let heightUnderBox = this.getDocumentHeight() - box.bottom;
                let searchFieldHeight = this.selectDropdownSearch.clientHeight;

                let freeSpace = Math.max(heightAboveBox, heightUnderBox) - searchFieldHeight;
                this.numberItemsInSelectBox = Math.min(
                    Math.max(Math.floor(freeSpace / this.itemHeightInSelectBox), 2),
                    this.maxItemsInSelectBox
                );

                let parentTop = highLevelParent.parentNode.offsetTop;

                if (heightAboveBox > heightUnderBox) {
                    // selectBox expended up
                    this.selectBoxTop =
                        node.offsetTop + parentTop - (this.selectBoxHeight + searchFieldHeight);
                } else {
                    // selectBox expended down
                    this.selectBoxTop = node.offsetTop + parentTop + box.height;
                }

                this.$nextTick(() => {
                    this.selectionElement.getElementsByTagName('input')[0].focus();
                });
            });
        },

        /**
         * Adds selected staff to the assignment
         * @param {int} id Staff ID
         */
        selectStaff(id) {
            this.$root.$emit('hideHelp');
            if (!this.selectionTarget.selectedStaff.includes(id)) {
                this.makeAssignmentUpdate(id, true);
                this.$nextTick(() => {
                    this.updateSelectionBox(selectedNode);
                });
            }
        },

        /**
         * Gets IDs of staff assigned to given cell
         * @param {int} shift Shift No (0 - 9)
         * @param {int} locationId Location ID
         * @param {String} cell Type of cell (dia1 / duo2 - DI for DIrect, DU for duty, O_bservers or A_ssistance, 1st/2nd)
         * @return {int[]}
         */
        cellSelectedStaff(shift, locationId, cell) {
            let location = this.locations.find(i => i.location_id === locationId);
            if (!location) {
                return [];
            }

            let type = cell[1] === 'i' ? 'direct' : 'duty';
            let call = cell[2] === 'o' ? 'observers' : 'assistance';
            let n = cell[3] === '1' ? 0 : 1;

            let chainPart = this.assignmentChainComplete(
                call,
                this.assignmentChain(type, shift, location.assignments)
            )[n];

            return [].concat(chainPart.users, chainPart.groups);
        },

        /**
         * Removes staff from assignment cell
         * @param {int} locationId Location ID
         * @param {String} cell Cell class name (e.g. dio1, dua2)
         * @param {int} staffId Staff ID
         */
        removeStaff(locationId, cell, staffId) {
            this.$root.$emit('hideHelp');
            this.selectionTarget = {
                location: locationId,
                cell: cell,
                selectedStaff: [],
            };
            this.makeAssignmentUpdate(staffId, false);
            this.hideSelection();
        },

        handlerResizeWindow() {
            this.refreshCatchNetLineInfo();
            this.hideSelection();
        },

        /**
         * Hides staff selection menu
         */
        hideSelection() {
            if (this.selectionVisible) {
                this.selectionVisible = false;
            }
        },

        /**
         * Update selected assignments with add/remove staff
         * @param {int} staffId ID of the staff member/staff group
         * @param {Boolean} operation true for staff addition and false for removal
         */
        makeAssignmentUpdate(staffId, operation) {
            let staff = this.staffArray.find(i => i.id === staffId);
            let locations;
            let locationSelected = this.locations.find(i => i.location_id === this.selectionTarget.location);

            let selectedLocationsArray = this.displayedLocations.filter(
                (l, i) => !!this.selectedLocations[i]
            );

            // use selected locations for operation only when user changes cell in selected location
            if (
                selectedLocationsArray.length > 0 &&
                selectedLocationsArray.some(l => l.location_id === locationSelected.location_id)
            ) {
                locations = selectedLocationsArray;
            } else {
                locations = [locationSelected];
            }

            let cellType = ('' + this.selectionTarget.cell)
                .split(' ')
                .find(i => i[0] === 'd' && i.length === 4);
            let type = cellType[1] === 'i' ? 'direct' : 'duty';
            let call = cellType[2] === 'o' ? 'observers' : 'assistance';
            let n = cellType[3] === '1' ? 0 : 1;

            locations.forEach(l => {
                l.assignments = this.changeSelectedStaff(
                    type,
                    call,
                    this.selectedShift,
                    n,
                    staff,
                    operation,
                    l.assignments,
                    l.location_id
                );
            });
            this.validateLocations();
            this.assignmentsChanged = true;
            this.selectionTarget.selectedStaff.push(staffId);

            this.refreshCatchNetLineInfo();
        },

        refreshCatchNetLineInfo() {
            this.$nextTick(() => {
                let rows = document.querySelectorAll('.arow');

                rows.forEach(row => {
                    let locationId = row.getAttribute('locationId');

                    let subrows = row.querySelectorAll('.acells-assignments');
                    subrows.forEach((subrow, index) => {
                        let rowType = index === 0 ? 'observers' : 'assistance';

                        let cells = subrow.querySelectorAll('.acell-wrap');
                        let maxHeight = Math.max(...[...cells].map(cell => cell.offsetHeight));

                        this.catchNetLines = this.catchNetLines.filter(item => {
                            // item === {
                            //    locationId: String,
                            //    type: 'observers' || 'assistance',
                            //    numberOfLines: Number,
                            // }
                            return !(item.locationId === locationId && item.type === rowType);
                        });

                        this.catchNetLines.push({
                            locationId,
                            type: rowType,
                            numberOfLines: Math.max(Math.round(maxHeight / 27), 2),
                        });
                    });
                });
            });
        },

        /**
         * Moves selection in staff selection menu to the next line (if available)
         */
        pointerForward() {
            if (this.pointer < this.filteredAssignableStaff.length - 1) {
                this.pointer++;
                let pointerPosition = this.pointer * this.itemHeightInSelectBox;
                if (
                    this.$refs.list.scrollTop <=
                    pointerPosition - this.itemHeightInSelectBox * MAX_ELEMENTS_SSMENU
                ) {
                    this.$refs.list.scrollTop =
                        pointerPosition - this.itemHeightInSelectBox * (MAX_ELEMENTS_SSMENU - 1);
                }
            }
        },

        /**
         * Moves selection in staff selection menu to the previous line (if available)
         */
        pointerBackward() {
            if (this.pointer > 0) {
                this.pointer--;
                let pointerPosition = this.pointer * this.itemHeightInSelectBox;
                if (this.$refs.list.scrollTop >= pointerPosition) {
                    this.$refs.list.scrollTop = pointerPosition;
                }
            }
        },

        /**
         * Adds selected staff to cell
         */
        addPointerElement() {
            if (this.filteredAssignableStaff.length > 0) {
                this.selectStaff(this.filteredAssignableStaff[this.pointer].id);
            }
        },

        /**
         * Makes staff array from part of assignments
         * @param {String} type Type of assignment: direct or duty
         * @param {int} shift Shift No (0 - 9)
         * @param {String} call Call type - observers/assistance
         * @param {int} n Number of assignment inside escalation chain (first - 0 or second - 1)
         * @param {Object} assignments Assignments object from location
         * @return {Object[]} Staff array
         */
        assignmentArrayByType(type, shift, call, n, assignments) {
            return orderBy(
                cloneDeep(
                    this.assignmentArray(
                        this.assignmentChainPart(call, n, this.assignmentChain(type, shift, assignments))
                    )
                ),
                'name'
            );
        },

        /**
         * Makes staff array from assignments
         * @param {int} shift Shift No (0 - 9)
         * @param {String} cellType Type of cell (dia1 / duo2 - DI for DIrect, DU for duty, O_bservers or A_ssistance, 1st/2nd)
         * @param {Object} assignments Assignments object from location
         * @return {Object[]} Staff array
         */
        assignmentArrayByCellType(shift, cellType, assignments) {
            let type = cellType[1] === 'i' ? 'direct' : 'duty';
            let call = cellType[2] === 'o' ? 'observers' : 'assistance';
            let n = cellType[3] === '1' ? 0 : 1;

            return this.assignmentArrayByType(type, shift, call, n, assignments);
        },

        /**
         * Makes staff array for selection
         * @param {{users: int[], groups: int[]}} chainPart Assignment chain part object
         * @return {Object[]} Staff array
         */
        assignmentArray(chainPart) {
            let ids = [].concat(chainPart.users, chainPart.groups);

            return this.staffArray.filter(s => ids.includes(s.id));
        },

        /**
         * Get messages for invalid assignment
         * @param {String} assignmentType 'observers' or 'assistance'
         * @param {Boolean} validMax true if the assignment meets MAX criteria
         * @param {Boolean} validDiff true if the assignment meets DIFF criteria
         * @return {String} message
         */
        getInvalidMessages(assignmentType, validMax, validDiff) {
            let errors = [];

            if (!validDiff) {
                errors.push(
                    assignmentType === 'observers'
                        ? this.observersErrorMessageDifferent
                        : this.assistanceErrorMessageDifferent
                );
            }

            if (!validMax) {
                errors.push(this.errorMessageMax);
            }

            return errors;
        },

        /**
         * Checks location for errors in assignments
         * Should detect same assignments in different cells (for different call types), and max 16 (ASSIGNMENTS_MAX_LENGTH) numbers per cell
         * Same assignments means same list of phone numbers
         */
        validateLocation(location) {
            let shifts = this.dutiesArray.map(i => String(i.value));

            let valid = true;

            // Get items (users and groups) inside each assignment
            // Also collect observers/assistance assignments into observers/assistance.
            let observers = [];
            location.dio1 = {
                valid: true,
                validMax: true,
                validDiff: true,
                type: 'observers',
                items: this.assignmentArrayByType('direct', null, 'observers', 0, location.assignments),
            };
            observers.push(location.dio1);
            location.dio2 = {
                valid: true,
                validMax: true,
                validDiff: true,
                type: 'observers',
                items: this.assignmentArrayByType('direct', null, 'observers', 1, location.assignments),
            };
            observers.push(location.dio2);
            location.duo1 = {};
            shifts.forEach(shift => {
                location.duo1[shift] = {
                    valid: true,
                    validMax: true,
                    validDiff: true,
                    type: 'observers',
                    items: this.assignmentArrayByType('duty', shift, 'observers', 0, location.assignments),
                };
                observers.push(location.duo1[shift]);
            });
            location.duo2 = {};
            shifts.forEach(shift => {
                location.duo2[shift] = {
                    valid: true,
                    validMax: true,
                    validDiff: true,
                    type: 'observers',
                    items: this.assignmentArrayByType('duty', shift, 'observers', 1, location.assignments),
                };
                observers.push(location.duo2[shift]);
            });

            let assistance = [];
            location.dia1 = {
                valid: true,
                validMax: true,
                validDiff: true,
                type: 'assistance',
                items: this.assignmentArrayByType('direct', null, 'assistance', 0, location.assignments),
            };
            assistance.push(location.dia1);
            location.dia2 = {
                valid: true,
                validMax: true,
                validDiff: true,
                type: 'assistance',
                items: this.assignmentArrayByType('direct', null, 'assistance', 1, location.assignments),
            };
            assistance.push(location.dia2);
            location.dua1 = {};
            shifts.forEach(shift => {
                location.dua1[shift] = {
                    valid: true,
                    validMax: true,
                    validDiff: true,
                    type: 'assistance',
                    items: this.assignmentArrayByType('duty', shift, 'assistance', 0, location.assignments),
                };
                assistance.push(location.dua1[shift]);
            });
            location.dua2 = {};
            shifts.forEach(shift => {
                location.dua2[shift] = {
                    valid: true,
                    validMax: true,
                    validDiff: true,
                    type: 'assistance',
                    items: this.assignmentArrayByType('duty', shift, 'assistance', 1, location.assignments),
                };
                assistance.push(location.dua2[shift]);
            });

            // Validation

            // 1) Check if each assignment contains maximum of ASSIGNMENTS_MAX_LENGTH phone numbers.
            //    And also simultaneously compute phone number lists in each assignment.
            //    The number lists are uniq-sorted and stringified, for example [5,5,2,4] becomes '2-4-5'.
            [...observers, ...assistance].forEach(assignment => {
                assignment.phoneList = uniq(
                    orderBy(
                        assignment.items.reduce((phoneList, item) => {
                            // for each item (group or user)
                            item.tooltipTitle =
                                item.title + (item.callIds ? ' (' + item.callIds.join(', ') + ')' : '');
                            return [...phoneList, ...item.callIds];
                        }, [])
                    )
                );
                assignment.phoneListStr = assignment.phoneList.join('-');
                assignment.validMax = assignment.phoneList.length <= ASSIGNMENTS_MAX_LENGTH;
                valid = valid && assignment.validMax;
            });

            // 2) Check if observers and assistance calls have different assignments
            observers.forEach(assignmentO => {
                assistance.forEach(assignmentA => {
                    let validDiff = !(
                        assignmentO.phoneListStr && assignmentO.phoneListStr === assignmentA.phoneListStr
                    );
                    assignmentO.validDiff = assignmentO.validDiff && validDiff;
                    assignmentA.validDiff = assignmentA.validDiff && validDiff;
                    valid = valid && validDiff;
                });
            });

            // 3) Set error message once per assignment
            [...observers, ...assistance].forEach(assignment => {
                assignment.invalidMessages = this.getInvalidMessages(
                    assignment.type,
                    assignment.validMax,
                    assignment.validDiff
                );
                assignment.valid = assignment.validMax && assignment.validDiff;
            });

            // Let vue know that location.valid changed
            this.$set(location, 'valid', valid);
        },

        /**
         * Validate all locations
         */
        validateLocations() {
            this.staffArray.forEach(staff => {
                staff.overloaded = this.checkStaff(staff);
            });
            this.locations.forEach(l => {
                this.validateLocation(l);
            });
        },

        /**
         * Is location subtree valid (location and it's children)
         */
        isLocationSubtreeValid(location) {
            return (
                location.valid &&
                location.childrenIds.reduce((childrenValid, childLocationId) => {
                    let childLocation = this.locations.find(l => l.location_id === childLocationId);
                    return childrenValid && childLocation.valid;
                }, true)
            );
        },

        /**
         * Is room location subtree valid (location and it's children)
         */
        isRoomLocationSubtreeInvalid(location) {
            return !this.isLocationSubtreeValid(location) && location.type === 6;
        },

        /**
         * Removes non-unique elements from array
         * @param {Array} arr
         * @return {Array}
         */
        uniqueArray(arr) {
            return arr.length > 0 ? [...new Set(arr)] : [];
        },

        /**
         * Transforms assignment chain part to list of phone numbers (call ids)
         * @param {{users: int[], groups: int[]}} cp Assignment chain part object
         * @return {String[]} phone numbers
         */
        chainPartToNumbers(cp) {
            return this.uniqueArray(
                []
                    .concat(cp.users, cp.groups)
                    .map(i => this.staffArray.find(e => e.id === i) || {})
                    .reduce((a, v) => (!!v.callIds && v.callIds.length > 0 ? [...a, ...v.callIds] : a), [])
            );
        },

        loadData() {
            this.showLoading(true);
            this.prevSelectedShift = this.selectedShift;
            this.resetData();

            return Promise.all([
                this.loadStaff(),
                this.loadGroupsList(),
                this.loadLocations(),
                this.loadDuties(),
            ])
                .then(() => {
                    locationsLoaded = locationsLoaded.map(location => ({
                        ...location,
                        childrenIds: locationsLoaded
                            .filter(i => i.parent_id === location.location_id)
                            .map(i => i.location_id),
                    }));
                    this.locations = locationsLoaded;
                    this.locationsCopy = cloneDeep(locationsLoaded);
                    this.staffArray = this.makeStaffArray(staff, staffGroups);
                    this.dutiesArray = dutiesLoaded;
                    this.validateLocations();
                    this.calcOverloadedStaff(this.locations);
                    this.validateLocations();
                    // restore previously selected shift (if it was present before and is in shifts list now)
                    if (this.dutiesArray.length > 0) {
                        let prevShift =
                            this.prevSelectedShift !== null
                                ? this.dutiesArray.findIndex(i => i.value === this.prevSelectedShift)
                                : -1;
                        this.selectedShift = prevShift !== -1 ? this.prevSelectedShift : this.savedShift;
                    }

                    this.setSearchEnabled(this.locations.length > 0);
                    this.refreshFilteredLocations();
                    this.dataLoaded = true;
                    this.showLoading(false);
                })
                .catch(
                    ifIsNotCanceled({
                        callback: () => {
                            this.setSearchEnabled(this.locations.length > 0);
                            this.resetData();
                            this.dataLoaded = true;
                        },
                    })
                )
                .then(() => {
                    this.$nextTick(() => setSelectableItems(this.$refs.asgtable));
                    this.refreshCatchNetLineInfo();
                });
        },

        loadLocations() {
            return resourceAssignments({
                id: this.userAreaId,
                cancelToken: this.cancelToken.token,
            }).then(response => {
                locationsLoaded = this.cleanLocations(response.data ? sortLocations(response.data) : []);
            });
        },

        loadStaff() {
            return resourceStaffMembers({
                cancelToken: this.cancelToken.token,
            }).then(response => {
                let data = Array.isArray(response.data) ? updateStaffMembers(response.data) : [];
                staff = data.filter(
                    item =>
                        item.areas !== null &&
                        item.areas.some(area => area.id === this.userAreaId && area.primary)
                );
            });
        },

        loadGroupsList() {
            return resourceStaffGroupsInAA({
                id: this.userAreaId,
                cancelToken: this.cancelToken.token,
            }).then(response => {
                staffGroups = response.data ? response.data : [];
            });
        },

        /**
         * Loads shifts data from server
         */
        loadDuties() {
            return resourceDuties({
                id: this.userAreaId,
                cancelToken: this.cancelToken.token,
            }).then(response => {
                dutiesLoaded = this.generateDutiesArray(response.data ? response.data : []);
            });
        },

        save() {
            return this.iterativeSave()
                .then(() => {
                    this.assignmentsChanged = false;
                    this.popup({
                        type: SUCCESS,
                        header: this.$t('common.success'),
                        text: this.$t('common.saved'),
                    });
                })
                .catch(
                    ifIsNotCanceled({
                        showPopUp: false,
                        hideLoader: false,
                        callback: response => {
                            if (response.status === 504 || response.status === 404) {
                                return this.loadData();
                            }
                        },
                    })
                )
                .then(() => {
                    this.dataLoaded = true;
                });
        },

        /**
         * Launches the process of recursive saving of locations array
         * @returns {Promise}
         */
        async iterativeSave() {
            let preparedLocations = this.prepareLocationsForSaving(this.changedLocations);
            let phoneNumbersToSave = 0;
            let start = 0;
            this.progressBarStart(this.$t('progressBar.saving'));
            for (let i in preparedLocations) {
                if (store.state.progressBar.isCanceled) {
                    this.progressBarHide();
                    return Promise.reject('');
                }
                phoneNumbersToSave += this.getPhoneNumbersCount(preparedLocations[Number(i)].assignments);
                if (
                    phoneNumbersToSave >= MAX_PHONES_FOR_SAVE ||
                    (Number(i) + 1) % LOCATIONS_FOR_SAVE_NUMBER === 0 ||
                    Number(i) === preparedLocations.length - 1
                ) {
                    try {
                        let savedLocations = preparedLocations.slice(start, Number(i) + 1);
                        await this.savePartChangedLocations(savedLocations).then(() => {
                            savedLocations.forEach(savedLocation => {
                                let { location_id } = savedLocation;
                                let locationCopy = find(this.locationsCopy, { location_id });

                                let {
                                    direct: savedDirectAssignments,
                                    duty: savedDutyAssignments,
                                } = savedLocation.assignments;

                                locationCopy.assignments = {
                                    ...locationCopy.assignments,
                                    direct: cloneDeep(savedDirectAssignments),
                                    duty: cloneDeep(savedDutyAssignments),
                                };
                            });
                        });
                        start = Number(i) + 1;
                        phoneNumbersToSave = 0;
                    } catch (error) {
                        this.progressBarHide();
                        return Promise.reject(error);
                    }
                    this.progressBarUpdate((i * 100.0) / preparedLocations.length);
                }
            }
            this.progressBarHide();

            return Promise.resolve();
        },

        /**
         * Counts unique phone numbers for all assignments cells for location
         * @param Object location with assignments property
         * @returns Number
         */
        getPhoneNumbersCount(assignments) {
            let directChain = this.assignmentChain('direct', 0, assignments);
            let directChainObservers = this.assignmentChainComplete('observers', directChain);
            let directChainAssistance = this.assignmentChainComplete('assistance', directChain);
            let shifts = this.dutiesArray.map(i => i.value);
            const countObservers = chainObservers =>
                this.chainPartToNumbers(chainObservers[0]).length +
                this.chainPartToNumbers(chainObservers[1]).length;
            const countAssistance = chainAssistance =>
                this.chainPartToNumbers(chainAssistance[0]).length +
                this.chainPartToNumbers(chainAssistance[1]).length;
            let commonCount = countObservers(directChainObservers) + countAssistance(directChainAssistance);

            for (let i = 0; i < shifts.length; i++) {
                let shift = shifts[i];
                let dutyChain = this.assignmentChain('duty', shift, assignments);
                let dutyChainObservers = this.assignmentChainComplete('observers', dutyChain);
                let dutyChainAssistance = this.assignmentChainComplete('assistance', dutyChain);
                commonCount =
                    commonCount + countObservers(dutyChainObservers) + countAssistance(dutyChainAssistance);
            }
            return commonCount;
        },

        /**
         * Try to save array of locations. In case of base timeout error reduces array twice if possible. Returns reject
         * in case of 5 API rejects in a row
         * @param locations - array of objects to save
         * @dbRejects - current number of API rejects
         * @return {Promise}
         */
        async savePartChangedLocations(locations, dbRejects = 0) {
            try {
                let response = await resourceAssignments({
                    method: 'post',
                    id: this.userAreaId,
                    data: locations,
                    cancelToken: this.cancelToken.token,
                });
                dbRejects = 0;
                return response;
            } catch (error) {
                if (dbRejects < 5 && error.status !== 403) {
                    await (() => new Promise(resolve => setTimeout(resolve, 60000)))();
                    let res = [];
                    let step = locations.length > 1 ? Math.floor(locations.length / 2) : 1;
                    for (let j = 0; j < locations.length + 1; j += step) {
                        if (locations.slice(j, j + step).length) {
                            res.push(
                                await this.savePartChangedLocations(
                                    locations.slice(j, j + step),
                                    dbRejects + 1
                                )
                            );
                        }
                    }

                    return Promise.all(res);
                }
                this.popup({
                    type: ERROR,
                    header: this.$t('common.error'),
                    text: error.statusText,
                });

                return Promise.reject(error);
            }
        },

        /**
         * Check if location is shown
         * @param {Object} location - location object
         * @returns {Boolean}
         */
        isLocationShown(location) {
            return (
                (!this.searchKeyword || this.matchesWithLinked(location)) &&
                (!location.parent_id || this.expandedLocationIds.includes(location.parent_id))
            );
        },

        /**
         * Check if location (or its parent or any child) matches witch search keyword
         * @param {Object} location - location object
         * @returns {Boolean}
         */
        isLocationFound(location) {
            return !this.searchKeyword || this.matchesWithLinked(location);
        },

        /**
         * Check if location is expanded
         * @param {Object} location - location object
         * @returns {Boolean}
         */
        isLocationExpanded(location) {
            return this.expandedLocationIds.includes(location.location_id);
        },

        /**
         * Collapse all locations
         */
        collapseAllLocations() {
            if (this.searchKeyword) {
                this.expandedLocationIdsFromData = [];
            } else {
                this.collapseAllLocationsInStore();
            }
        },

        /**
         * Collapse a location
         * @param {Number} location_id
         */
        collapseLocation(location_id) {
            if (this.searchKeyword) {
                this.expandedLocationIdsFromData = this.expandedLocationIdsFromData.filter(
                    id => id !== location_id
                );
            } else {
                this.collapseLocationInStore(location_id);
            }
        },

        /**
         * Expand a location
         * @param {Number} location_id
         */
        expandLocation(location_id) {
            if (this.searchKeyword && !this.expandedLocationIdsFromData.includes(location_id)) {
                this.expandedLocationIdsFromData.push(location_id);
            } else {
                this.expandLocationInStore(location_id);
            }

            this.refreshCatchNetLineInfo();
        },

        resetData() {
            this.assignmentsChanged = false;
            this.staffArray = [];
            this.locationsInvalid = [];
            this.locations = [];
            this.locationsCopy = [];
            this.dutiesArray = [];
            this.modalDefaultData = {
                observers: true,
                groups: [],
            };
            this.selectionTarget = {
                location: null,
                cell: '',
                selectedStaff: [],
            };
            this.selectedShift = null;
            this.dataLoaded = false;
            this.callIdLocationCount = {};

            // data to be loaded via AJAX calls
            locationsLoaded = null;
            staff = [];
            staffGroups = [];
            dutiesLoaded = null;
        },

        refreshFilteredLocations() {
            let filteredLocations = this.locations.filter(location => this.isLocationFound(location));
            if (filteredLocations.length !== this.filteredLocations.length) {
                // change page if the list changed
                this.pagination.current_page = 1;
            }
            this.filteredLocations = filteredLocations;
            this.refreshDisplayedLocationsPages();
        },

        refreshDisplayedLocationsPages() {
            // Note that locations are sorted so that children go right after its parent
            let i = 0; // currently processed location
            let n = this.filteredLocations.length;
            let locationsLeft = [...this.filteredLocations];
            let pages = [];
            while (i < n) {
                let page = [];
                let nRoomsInPage = 0;
                // Take locations to the page until ASSIGNMENTS_ROOMS_PER_PAGE rooms are counted
                while (i < n && nRoomsInPage < ASSIGNMENTS_ROOMS_PER_PAGE) {
                    if (!locationsLeft[0].parent_id) {
                        nRoomsInPage++;
                    }
                    // Move currently processed location from locationsLeft to current page
                    page.push(locationsLeft[0]);
                    locationsLeft.shift();
                    i++;
                }
                // Take all remaining children to the page
                while (i < n && locationsLeft[0] && locationsLeft[0].parent_id) {
                    page.push(locationsLeft[0]);
                    locationsLeft.shift();
                    i++;
                }
                pages.push(page);
            }
            this.displayedLocationsPages = pages;
            this.pagination.last_page = pages.length;
        },

        resetLocationsSelection() {
            this.selectedLocations = [];
            this.selectingLocations = [];
            this.$nextTick(() => setSelectableItems(this.$refs.asgtable));
        },

        onPageChange() {
            this.resetLocationsSelection();
            this.scrolledElement.scrollTop = 0;
            this.saveScrollPositionAndPage({
                scrollPosition: 0,
                savedCurrentPage: this.searchKeyword ? this.savedCurrentPage : this.pagination.current_page,
            });
        },
    },
};
// TODO: show loader when page is changing
</script>
